import { RawButton, Translation } from '@ps/web-shared-components';
import React from 'react';

import { TXTMOB_Give_Feedback } from './withFeedbackButton.messages.json';
import styles from './withFeedbackButton.scss';

interface WithFeedbackProps {
  showFeedbackButton: boolean;
  showFeedbackScreen(): void;
}

const withFeedbackButton =
  <P extends object>(Component: React.ComponentType<P>): React.FC<P & WithFeedbackProps> =>
  ({ showFeedbackButton, showFeedbackScreen, ...props }: WithFeedbackProps) =>
    (
      <>
        <Component {...(props as P)} />
        {showFeedbackButton && (
          <div className={styles.container}>
            <RawButton
              variant="primary"
              size="large"
              className={styles.button}
              onClick={showFeedbackScreen}
            >
              <Translation {...TXTMOB_Give_Feedback} />
            </RawButton>
          </div>
        )}
      </>
    );

export default withFeedbackButton;
